<script>
import Drawer from "@/components/drawer";
import { required } from "vuelidate/lib/validators";
import { icons } from "@/helpers/data-fontawesome";

// Custom Components
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/APIService/user.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    PageHeader,
  },
  data() {
    return {
      title: "App Feature",
      icons: icons,
      typeBaseIcons: [],
      appFeatues: [],
      openStatusDrawer: false,
      isLoading: false,
      isEditFeature: false,
      isBtnLoading: false,
      submitted: false,
      appFeatureData: {
        name: null,
        icon: null,
        price: 0.0,
        price_type: "pre_month",
      },
    };
  },
  validations: {
    appFeatureData: {
      name: {
        required,
      },
      icon: {
        required,
      },
      price: {
        required,
      },
      price_type: {
        required,
      },
    },
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getAppFeatures();
  },
  methods: {
    // Method is use for get app feature list
    async getAppFeatures() {
      this.isLoading = true;
      try {
        const response = await UserService.getAppFeature();
        if (response) {
          this.appFeatues = response;
          this.isLoading = false;
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is use for add and update app features
    async addUpdateData() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let data = {
          name: this.appFeatureData.name,
          icon: this.appFeatureData.icon,
          price: this.appFeatureData.price,
          price_type: this.appFeatureData.price_type,
        };
        if (this.isEditFeature) {
          try {
            const response = await UserService.editAppFeature(
              this.appFeatureData.id,
              data
            );
            if (response) {
              this.appFeatues = this.appFeatues.map((item) => {
                if (item.id == response.id) {
                  item = response;
                }
                return item;
              });
              this.isBtnLoading = false;
            }
          } catch (error) {
            this.isBtnLoading = false;
            errorHandler(error);
          }
        } else {
          try {
            data = {
              ...data,
              feature_code:
                this.appFeatues[this.appFeatues.length - 1].feature_code + 1,
            };
            const response = await UserService.addAppFeature(data);
            if (response) {
              this.appFeatues.push(response);
              this.isBtnLoading = false;
            }
          } catch (error) {
            this.isBtnLoading = false;
            errorHandler(error);
          }
        }
        this.closer();
      }
    },
    // Method is use for update status
    async updateStatus(id, data) {
      try {
        const response = await UserService.editAppFeature(id, data);
        if (response) {
          Middleware.notification("Status successfully changed !!", "success");
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is use for set icons
    setIcons() {
      let brand = [];
      let solid = [];
      let regular = [];
      for (let entry of icons) {
        if (entry.attributes.membership.free.length && entry.id != undefined) {
          for (let value of entry.attributes.membership.free) {
            switch (value) {
              case "brands":
                brand.push({ icon: `fab fa-${entry.id}`, show: entry.id });
                break;
              case "solid":
                solid.push({ icon: `fas fa-${entry.id}`, show: entry.id });
                break;
              default:
                regular.push({ icon: `far fa-${entry.id}`, show: entry.id });
            }
          }
        }
      }
      this.typeBaseIcons = [
        {
          iconName: "brands",
          icons: brand,
        },
        { iconName: " solid", icons: solid },
        { iconName: "regular", icons: regular },
      ];
    },
    // Method is use for set single icon
    setIcon(icon) {
      this.appFeatureData.icon = icon.icon;
      this.$bvModal.hide("icon-list-modal");
    },
    // Method is use for handle drawer open/close
    detailer(data) {
      if (data.name) {
        this.appFeatureData = data;
        this.isEditFeature = true;
      }
      this.openStatusDrawer = !this.openStatusDrawer;
    },
    // Method is use for handle close drawer
    closer() {
      this.openStatusDrawer = !this.openStatusDrawer;
      this.isEditFeature = false;
      this.appFeatureData = {
        name: null,
        icon: null,
        price: 0.0,
        price_type: "pre_month",
      };
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="detailer"
      text="Add New Feature"
      :isButton="true"
    />
    <b-card>
      <div class="table-responsive">
        <v-table class="table mb-0" :data="appFeatues">
          <thead class="table-light" slot="head">
            <tr>
              <v-th sortKey="feature_code">Feature Code</v-th>
              <v-th sortKey="name">Name</v-th>
              <th>Icon</th>
              <v-th sortKey="price">Price</v-th>
              <v-th sortKey="price_type">Price Type</v-th>
              <th>Active</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr v-for="item in 10" :key="item">
              <td class="placeholder-glow" v-for="no in 7" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody v-if="!isLoading" slot="body" slot-scope="{ displayData }">
            <tr v-for="(feature, index) in displayData" :key="index">
              <td @click="detailer(feature)">
                {{ feature.feature_code }}
              </td>
              <td class="text-capitalize" @click="detailer(feature)">
                {{ feature.name }}
              </td>
              <td class="text-capitalize" @click="detailer(feature)">
                <i :class="feature.icon" class="fs-5"> </i>
              </td>
              <td class="text-capitalize" @click="detailer(feature)">
                ${{ feature.price }}
              </td>
              <td class="text-capitalize" @click="detailer(feature)">
                {{ feature.price_type.replace("_", " ") }}
              </td>
              <td>
                <div class="form-check form-switch my-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="feature.is_active"
                    @click="
                      updateStatus(feature.id, {
                        is_active: !feature.is_active,
                      })
                    "
                  />
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <i
                    class="fas fa-pencil-alt text-success fs-5"
                    v-b-popover.hover="'Edit'"
                  ></i>
                </div>
              </td>
            </tr>
          </tbody>
        </v-table>
      </div>
    </b-card>

    <!-- Detail drawer -->
    <Drawer
      @close="closer()"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="800"
    >
      <div v-if="openStatusDrawer">
        <h4 class="offcanvas-title">
          {{
            appFeatureData.name && isEditFeature
              ? "Update " + appFeatureData.name + " Feature"
              : "Adding A New Feature"
          }}
        </h4>
        <hr />
        <div class="row">
          <div class="col-sm-6">
            <div class="mb-3">
              <label for="feature_name">Name</label
              ><span class="text-danger"> *</span>
              <input
                id="name"
                name="feature_name"
                type="text"
                class="form-control"
                placeholder="Enter Feature Name"
                autocomplete="off"
                v-model.trim="appFeatureData.name"
                :class="{
                  'is-invalid': submitted && $v.appFeatureData.name.$error,
                }"
              />
              <div
                v-if="submitted && $v.appFeatureData.name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.appFeatureData.name.required"
                  >Name is required.</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <b-form-group class="mb-3" label-for="icon-input">
              <span slot="label"
                >Icon <span class="text-danger">*</span>
                <b-button
                  variant="outline-primary"
                  class="btn-sm ms-2"
                  v-b-modal.icon-list-modal
                  @click="setIcons"
                  >Select Icon</b-button
                ></span
              >

              <b-form-input
                disabled
                id="icon-input"
                type="text"
                placeholder="fa fas-pen"
                v-model="appFeatureData.icon"
                autocomplete="off"
                class=""
                :class="{
                  'is-invalid': submitted && $v.appFeatureData.icon.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.appFeatureData.icon.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.appFeatureData.icon.required"
                  >Icon is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <label for="price">Price</label
              ><span class="text-danger"> *</span>
              <input
                id="price"
                name="price"
                type="text"
                class="form-control"
                placeholder="Enter Feature Price"
                autocomplete="off"
                v-model.trim="appFeatureData.price"
                :class="{
                  'is-invalid': submitted && $v.appFeatureData.price.$error,
                }"
              />
              <div
                v-if="submitted && $v.appFeatureData.price.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.appFeatureData.price.required"
                  >Price is required.</span
                >
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <label for="price_type">Price Type</label
              ><span class="text-danger"> *</span>
              <select
                id="price_type"
                name="price_type"
                type="text"
                class="form-control"
                placeholder="Select Feature Price Type"
                autocomplete="off"
                v-model="appFeatureData.price_type"
                :class="{
                  'is-invalid':
                    submitted && $v.appFeatureData.price_type.$error,
                }"
              >
                <option value="per_month">Per Month</option>
                <option value="per_shift">Per Shift</option>
              </select>
              <div
                v-if="submitted && $v.appFeatureData.price_type.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.appFeatureData.price_type.required"
                  >Price Type is required.</span
                >
              </div>
            </div>
          </div>
          <hr />
          <div class="col-sm-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="closer"
              >Cancel</b-button
            >
            <b-button
              variant="outline-primary"
              class="float-end"
              @click="addUpdateData"
            >
              <i
                v-if="isLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i>
              {{ !isEditFeature ? "Save" : "Update" }}
            </b-button>
          </div>
        </div>
      </div>
    </Drawer>
    <!-- Modal is for add new folio -->
    <b-modal id="icon-list-modal" size="xl" centered hide-footer hide-header>
      <div class="row">
        <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 pb-0">
          <b-tab v-for="(icon, index) in typeBaseIcons" :key="index">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block">{{ icon.iconName }}</span>
            </template>
            <div class="row icon-demo-content" id="solid">
              <div
                class="col-xl-3 col-lg-4 col-sm-6"
                v-for="(icon, iconIndex) in icon.icons"
                :key="iconIndex"
                @click="setIcon(icon)"
              >
                <i :class="icon.icon"></i>{{ icon.show }}
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </div>
</template>
